import { render } from "./EditUsager.vue?vue&type=template&id=a3957638&scoped=true&ts=true"
import script from "./EditUsager.vue?vue&type=script&lang=ts"
export * from "./EditUsager.vue?vue&type=script&lang=ts"

import "./EditUsager.vue?vue&type=style&index=0&id=a3957638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3957638"]])

export default __exports__